// Lightweight analytics event hooks. Wires up to Plausible or any provider later.
// For MVP we just log to console + dispatch a CustomEvent so devtools / future
// integrations (Plausible, PostHog) can listen without code changes.

export function track(eventName, props = {}) {
    try {
        const detail = { event: eventName, props, t: Date.now() };
        if (typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent("a1:track", { detail }));
            // Plausible (when present) supports window.plausible(eventName, { props })
            if (typeof window.plausible === "function") {
                window.plausible(eventName, { props });
            }
        }
        // In dev, log so we can see events firing
        if (process.env.NODE_ENV !== "production") {
            // eslint-disable-next-line no-console
            console.debug("[a1:track]", eventName, props);
        }
    } catch {
        /* never fail UI on analytics */
    }
}

export const EVENTS = {
    PHONE_CLICK: "phone_click",
    ESTIMATE_START: "estimate_start",
    ESTIMATE_SUBMIT: "estimate_submit",
    MICRO_FORM_SUBMIT: "micro_form_submit",
    PHOTO_UPLOAD_START: "photo_upload_start",
    PHOTO_UPLOAD_SUBMIT: "photo_upload_submit",
    STORM_BANNER_VIEW: "storm_banner_view",
    STORM_CTA_CLICK: "storm_cta_click",
    FAQ_INTERACTION: "faq_interaction",
    ADMIN_LEAD_REVIEWED: "admin_lead_reviewed",
    HUMAN_REVIEW_COMPLETED: "human_review_completed",
};
